"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentSuccess = void 0;
const react_1 = __importStar(require("react"));
const organisms_1 = require("../../../../organisms");
const AppointmentSuccess_web_style_1 = require("./AppointmentSuccess.web.style");
const react_native_1 = require("react-native");
const atome_1 = require("../../../../atome");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
function AppointmentSuccess({ navigation }) {
    const [appointmentData, setAppointmentData] = (0, react_1.useState)();
    const [appointmentDoctor, setAppointmentDoctor] = (0, react_1.useState)();
    const getAppointmentInfos = async () => {
        const appointment = await async_storage_1.default.getItem('appointmentData');
        const doctor = await async_storage_1.default.getItem('appointmentDoctor');
        if (!appointment || !doctor) {
            navigation.navigate('Dashboard');
        }
        if (appointment && doctor) {
            setAppointmentData(JSON.parse(appointment));
            setAppointmentDoctor(JSON.parse(doctor));
            await async_storage_1.default.multiRemove(['appointmentData', 'appointmentDoctor']);
        }
    };
    (0, react_1.useEffect)(() => {
        getAppointmentInfos();
    }, []);
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, null,
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: [AppointmentSuccess_web_style_1.styles.container] },
                react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isDesktop
                        ? [
                            AppointmentSuccess_web_style_1.styles.marginBottom40,
                            AppointmentSuccess_web_style_1.styles.marginHorizontal35,
                            AppointmentSuccess_web_style_1.styles.marginTop35,
                        ]
                        : [AppointmentSuccess_web_style_1.styles.marginHorizontal35] },
                    Breakpoints_1.isDesktop && (react_1.default.createElement(atome_1.Text, { style: [AppointmentSuccess_web_style_1.styles.heading1] }, "VIDEOSPRECHSTUNDE")),
                    react_1.default.createElement(atome_1.Label, null, "Ihre Videosprechstunde wurde erfolgreich gebucht.")),
                react_1.default.createElement(react_native_1.View, { style: [
                        AppointmentSuccess_web_style_1.styles.row,
                        AppointmentSuccess_web_style_1.styles.marginTop20,
                        AppointmentSuccess_web_style_1.styles.selectedAppointmentContainer,
                    ] },
                    react_1.default.createElement(react_native_1.View, { style: [AppointmentSuccess_web_style_1.styles.positionRelative, AppointmentSuccess_web_style_1.styles.calendarIconContainer] },
                        react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: Breakpoints_1.isDesktop ? 90 : 80, color: Breakpoints_1.isDesktop ? '#fff' : '#3db384' }),
                        react_1.default.createElement(atome_1.Text, { style: [AppointmentSuccess_web_style_1.styles.heading3, AppointmentSuccess_web_style_1.styles.selectedDateDay] }, appointmentData
                            ? new Date(appointmentData.startDate)
                                .getDate()
                                .toLocaleString('de-DE', {
                                minimumIntegerDigits: 2,
                            })
                            : '?')),
                    react_1.default.createElement(react_native_1.View, { style: [
                            AppointmentSuccess_web_style_1.styles.column,
                            AppointmentSuccess_web_style_1.styles.marginLeft20,
                            AppointmentSuccess_web_style_1.styles.selectedAppointmentWrapper,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [AppointmentSuccess_web_style_1.styles.heading2, AppointmentSuccess_web_style_1.styles.selectedAppointmentHeader] }, "Ihre Videosprechstunde"),
                        react_1.default.createElement(react_native_1.View, null,
                            Breakpoints_1.isMobile && (react_1.default.createElement(atome_1.Text, { style: [AppointmentSuccess_web_style_1.styles.textBlack] }, "Datum / Uhrzeit:")),
                            react_1.default.createElement(atome_1.Text, { style: [
                                    Breakpoints_1.isDesktop
                                        ? AppointmentSuccess_web_style_1.styles.colorWhite
                                        : [AppointmentSuccess_web_style_1.styles.marginTop5, AppointmentSuccess_web_style_1.styles.textBlack, AppointmentSuccess_web_style_1.styles.textBold],
                                ] },
                                appointmentData &&
                                    new Date(appointmentData.startDate).toLocaleString('de-DE', {
                                        month: 'long',
                                        day: '2-digit',
                                        year: 'numeric',
                                        hour: 'numeric',
                                        minute: 'numeric',
                                    }),
                                ' ',
                                "Uhr")),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? AppointmentSuccess_web_style_1.styles.row : AppointmentSuccess_web_style_1.styles.column,
                                AppointmentSuccess_web_style_1.styles.marginTop20,
                            ] },
                            react_1.default.createElement(atome_1.Text, { style: [Breakpoints_1.isDesktop ? AppointmentSuccess_web_style_1.styles.colorWhite : [AppointmentSuccess_web_style_1.styles.textBlack]] }, "Arzt / \u00C4rztin:"),
                            react_1.default.createElement(atome_1.Text, { style: Breakpoints_1.isDesktop
                                    ? [AppointmentSuccess_web_style_1.styles.colorWhite, AppointmentSuccess_web_style_1.styles.marginLeft10]
                                    : [AppointmentSuccess_web_style_1.styles.marginTop5, AppointmentSuccess_web_style_1.styles.textBlack, AppointmentSuccess_web_style_1.styles.textBold] },
                                appointmentDoctor && appointmentDoctor?.doctor
                                    ? appointmentDoctor?.doctor.title === 'doctor'
                                        ? 'Dr.'
                                        : appointmentDoctor?.doctor.title === 'professor'
                                            ? 'Prof.'
                                            : ''
                                    : '',
                                appointmentDoctor && appointmentDoctor?.doctor.firstname,
                                ' ',
                                appointmentDoctor && appointmentDoctor?.doctor.lastname)),
                        react_1.default.createElement(atome_1.Text, { style: Breakpoints_1.isDesktop
                                ? [AppointmentSuccess_web_style_1.styles.colorWhite, AppointmentSuccess_web_style_1.styles.marginTop20]
                                : [
                                    AppointmentSuccess_web_style_1.styles.marginTop20,
                                    AppointmentSuccess_web_style_1.styles.textBlack,
                                    AppointmentSuccess_web_style_1.styles.lineHeight20,
                                ] }, "Der Termin wurde best\u00E4tigt. Auf Ihrem Dashboard werden Ihnen alle weiteren Informationen angezeigt."))),
                react_1.default.createElement(react_native_1.View, { style: [AppointmentSuccess_web_style_1.styles.row, AppointmentSuccess_web_style_1.styles.buttonContainer] },
                    react_1.default.createElement(react_native_1.Pressable, { style: [AppointmentSuccess_web_style_1.styles.button], onPress: () => navigation.navigate('Dashboard') },
                        react_1.default.createElement(atome_1.Text, { style: [AppointmentSuccess_web_style_1.styles.buttonText] }, "Zum Dashboard")))))));
}
exports.AppointmentSuccess = AppointmentSuccess;
